import { randomizeFromList } from "util/tools";
import { random } from "lib/util/rng";

const regions = [
  "Blackwater Reach",
  "Deadwood Vale",
  "Whisperwind Hollow",
  "Stoneshadow Ridge",
  "Reddust Plain",
  "Bleakfire Moor",
  "Silentthorn Wastes",
  "Ashenwood Heights",
  "Frostfall Gorge",
  "Nightwolf Canyon",
  "Starless Skyfields",
  "Ironsage Desert",
  "Coldlight Realm",
  "Ravencrag Basin",
  "Ghostwind Plateau",
  "Dustbone Valley",
  "Thunderfall Expanse",
  "Grimfrost Frontier",
  "Shadowmire Realm",
  "Twilight Echo Lands",
];

const cities = [
  "Bleakwater",
  "Crow's Hollow",
  "Dustveil",
  "Grimwood",
  "Ironridge",
  "Lost Mesa",
  "Ravenfall",
  "Shadowvale",
  "Thornfield",
  "Whisperwind",
  "Barren Plains",
  "Frostford",
  "Sorrow's End",
  "Scarwood",
  "Wraith's Crossing",
  "Ashen Peak",
  "Silent Prairie",
  "Forsaken Bluff",
  "Ghost Canyon",
  "Stone's Echo",
  "DreadGulch",
  "Voidsummit",
  "Mournbrook",
  "Shattered Spire",
  "Crimson Quarry",
  "Withergrass",
  "Echo's Lament",
  "Twilight's Crest",
  "Hollowshade",
  "Sunset Moors",
];

const randomNames = (type) => {
  const seenNames = new Set();
  const get = () => {
    const list = type === "city" ? cities : regions;
    const result = randomizeFromList(list, seenNames, random);

    return result;
  };
  return {
    get,
  };
};

let randomCityNames = randomNames("city");
let randomRegionNames = randomNames("region");

// The pools are module singletons and each keeps a `seenNames` set that is never cleared. One map
// per page load, so the app never notices; but a process that generates several maps exhausts
// 30 city names and 20 region names in two runs and starts handing back duplicates. GameMap calls
// this so every world is named from a full pool.
const resetNamePools = () => {
  randomCityNames = randomNames("city");
  randomRegionNames = randomNames("region");
};

// lang = makeRandomLanguage()
// key can have values: "city" or "region"
const makeName = (key) => {
  if (key === "city") return randomCityNames.get();

  return randomRegionNames.get();
};

export { makeName, resetNamePools };
